import {useCallback, useState} from "react";
import {Button, Form, Stack} from "react-bootstrap";
import {useRestClient} from "../../../client/SpmRestClient";
import {GenericResponsePayload} from "../../../types/GenericResponsePayload";
import {StringUtil} from "zavadil-ts-common";
import {useAlerts} from "../../../utils/UserAlerts";

export default function ContactsImportPage() {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [selectedFile, setSelectedFile] = useState<File | null>();

	const startImport =
		useCallback(
			() => {
				if (!selectedFile) return;
				restClient.import
					.import(selectedFile)
					.then(
						(response: GenericResponsePayload) => {
							response.success
								? userAlerts.info(StringUtil.toString(response.message))
								: userAlerts.err(StringUtil.toString(response.error));
						},
					)
					.catch((e) => userAlerts.err(e));
			},
			[restClient, userAlerts, selectedFile]
		);

	return (
		<div>
			<h1>Import</h1>
			<Form onSubmit={startImport}>
				<Stack gap={2}>
					<input
						id="file"
						type="file"
						name="file"
						onChange={(e) => e.target.files && setSelectedFile(e.target.files[0])}
					/>
					<Button onClick={startImport} disabled={!selectedFile}>Import</Button>
				</Stack>
			</Form>
		</div>
	);
}
